export const LAYOUT_PAGE_NAV_POINT_PREFIX = "layout-page-content";
